import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { getDefaultMiddleware } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import loadingReducer from "../features/loading/loadingSlice";
import peristReducer from "../features/persist/persistSlice";
import marketPlaceReducer from "../features/marketPlace/marketPlaceSlice";

import storage from "redux-persist/lib/storage";

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
});

const combinedReducer = combineReducers({
  loading: loadingReducer,
  users: userReducer,
  persist: peristReducer,
  marketPlace: marketPlaceReducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["persist"],
};
const persistedReducer = persistReducer(persistConfig, combinedReducer);

const rootReducer = (state, action) => {
  if (action.type === "users/logoutUser") {
    //this is use for clearing persist reducer
    storage.removeItem("persist:root");
    state = undefined;
    window.location.reload();
  }
  return persistedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
});
